var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.walletTypes),function(item,index){return (item.permission)?_c('div',{key:index,staticClass:"my-0 py-0"},[_c('v-switch',{staticClass:"my-0 py-0",attrs:{"label":item.title},model:{value:(_vm.value[item.value]),callback:function ($$v) {_vm.$set(_vm.value, item.value, $$v)},expression:"value[item.value]"}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }